import React from "react"
import { LayoutFAQs } from "trimble-terra"
import RichTextConnector from "../../../components/RichText/RichTextConnector"
import renderPaddingOrFullBleed from "../renderPaddingOrFullBleed"
import { formatCommonComponentFields } from "./formatLayoutFunctions"
import { formatPageLinks } from "../formatPageLinks"

const FormatAndRenderLayoutFaq = ({
  data,
  locale,
  siteIdentifier,
  homepageSlug,
  currentSpaceId,
}) => {
  const formattedComponentData = formatCommonComponentFields(
    data,
    locale,
    siteIdentifier,
    homepageSlug,
    currentSpaceId
  )

  const formattedFaqItems = data?.items?.map(item => {
    let formattedLink = null
    if (item?.ctaLink) {
      const formattedLinkData = formatPageLinks(
        item?.ctaLink,
        locale,
        siteIdentifier,
        homepageSlug,
        currentSpaceId
      )
      formattedLink = {
        label: formattedLinkData?.text,
        destination: formattedLinkData?.url,
      }
    }

    return {
      ...item,
      description: <RichTextConnector data={{ content: item?.description }} />,
      ctaLink: formattedLink,
    }
  })

  const formattedLayoutFaqData = {
    ...formattedComponentData,
    description: data?.layoutDescription ? (
      <RichTextConnector
        data={{ content: data?.layoutDescription }}
        includeClasses={false}
      />
    ) : null,
    faqItems: formattedFaqItems,
    faqType: data?.isAccordion ? "t2-collapsed" : "t2-expanded",
  }

  return <LayoutFAQs {...formattedLayoutFaqData} isWrapped={true} />
}

export default FormatAndRenderLayoutFaq
